export default __webpack_public_path__ + "img/bOWgXwIM.a269c124.svg";